import { render, staticRenderFns } from "./MergeBill.vue?vue&type=template&id=f822f556"
import script from "./MergeBill.vue?vue&type=script&lang=js"
export * from "./MergeBill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports